import React, { useState, useEffect } from 'react'
import { Form, Row, Input, Tooltip, Typography } from 'antd'
import { FormInstance } from 'antd/lib/form'
import { PlatformField } from './reducer'
import {
  renderFormControl,
  getFieldRules,
  getDateValueProps,
  useExpandAttrInitialValues,
  ExpandAttrFieldItem,
} from '../ExpandAttrField'
import Style from './detail.module.scss'
interface Props {
  form: FormInstance
  fieldList: any[]
  itemsList?: PlatformField[]
  onFieldsChange: () => void
  aiAuditErrorReasonForField?: any
  frontendHintText?: string // 四级类目前台提示文案（选择类目时带出）
}
// 拓展属性
const Expandattr: React.FC<Props> = (props) => {
  const {
    form,
    fieldList,
    itemsList,
    onFieldsChange,
    aiAuditErrorReasonForField,
    frontendHintText,
  } = props
  // eslint-disable-next-line
  const [levelState, setlevelState] = useState<string>('')
  const [codeList, setCodeList] = useState<string[]>([])
  useEffect(() => {
    const l = form.getFieldValue('level')
    setlevelState(l)
    // eslint-disable-next-line
  }, [form.getFieldValue('level')])

  useEffect(() => {
    setCodeList(itemsList?.map((item: PlatformField) => item.code) as string[])
  }, [itemsList])
  useEffect(() => {
    setCodeList(itemsList?.map((item: PlatformField) => item.code) as string[])
    // eslint-disable-next-line
  }, [])
  const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  }
  const itemLayou = {
    style: {
      width: '20%',
      marginBottom: '10px',
    },
  }

  // 字符串截取
  function changestrlength(value: any) {
    let title = null
    let styleObj = {}
    const name = value.name
    const index = 4
    if (isSameCode(codeList, value.platformCodeLabel)) {
      title = (
        <span>
          {value.name} <br />
          平台要求: {value.platformAbbreviationName}
        </span>
      )
      styleObj = { color: 'blue' }
    } else {
      title = value.name
    }
    if (name?.length > index) {
      const str = name.substring(0, index)
      return (
        <Tooltip title={title} getTooltipContainer={() => document.body}>
          <span style={styleObj}>{`${str}...`}</span>
        </Tooltip>
      )
    } else {
      return (
        <Tooltip title={title} getTooltipContainer={() => document.body}>
          <span style={styleObj}>{name}</span>
        </Tooltip>
      )
    }
  }
  // 判断两个数组中是否有相同项
  // arr1->当前选择的项目  arr2->当前属性所标记的项目属性组
  const isSameCode = (arr1: string[], arr2: string[]) => {
    let flag = false
    if (arr2 && arr1) {
      arr2.forEach((item) => {
        if (arr1.includes(item)) {
          flag = true
        }
      })
    }
    return flag
  }

  return (
    <>
      <Form
        {...formItemLayout}
        // name='expandattr'
        form={form}
        onFieldsChange={onFieldsChange}
        labelAlign="right"
        colon={false}
        style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
        size="small"
      >
        {frontendHintText ? (
          <div
            style={{
              margin: '8px 0',
              padding: '8px 12px',
              backgroundColor: '#fffbe6',
              border: '1px solid #ffe58f',
              borderRadius: '4px',
              color: '#614700',
              lineHeight: '1.6',
              whiteSpace: 'normal',
              wordBreak: 'break-all',
            }}
          >
            {frontendHintText}
          </div>
        ) : null}
        {/* 拓展属性 */}
        <Row className="expand-attr">
          {fieldList.map((item, index) => {
            const valueType = item.valueType || '2'
            const isDateType = valueType === '4'
            const placeholder =
              item.platformAbbreviationName &&
              isSameCode(codeList, item?.platformCodeLabel || [])
                ? item.platformAbbreviationName
                : '请输入'

            const dateValueProps = isDateType ? getDateValueProps() : {}

            return (
              <Form.Item
                key={index}
                label={changestrlength(item)}
                name={item.id}
                rules={getFieldRules(item as ExpandAttrFieldItem)}
                {...dateValueProps}
                {...itemLayou}
              >
                {renderFormControl({
                  item: item as ExpandAttrFieldItem,
                  placeholder,
                  form,
                })}
              </Form.Item>
            )
          })}
        </Row>
        <Tooltip
          placement="top"
          title={aiAuditErrorReasonForField?.join('\n')}
          overlayClassName={Style['custom-tooltip']}
          getPopupContainer={() => document.body}
        >
          {aiAuditErrorReasonForField?.map((i: any, index: number) => (
            <Typography.Text style={{ color: '#F57F17' }} ellipsis key={index}>
              {i}
            </Typography.Text>
          ))}
        </Tooltip>
      </Form>
    </>
  )
}

export default Expandattr
import React, { useState, useEffect } from 'react'
import { Form, Row, Input, Tooltip, Typography } from 'antd'
import { FormInstance } from 'antd/lib/form'
import { PlatformField } from './reducer'
import {
  renderFormControl,
  getFieldRules,
  getDateValueProps,
  useExpandAttrInitialValues,
  ExpandAttrFieldItem,
} from '../ExpandAttrField'
import Style from './detail.module.scss'
interface Props {
  form: FormInstance
  fieldList: any[]
  itemsList?: PlatformField[]
  onFieldsChange: () => void
  aiAuditErrorReasonForField?: any
  frontendHintText?: string // 四级类目前台提示文案（选择类目时带出）
}
// 拓展属性
const Expandattr: React.FC<Props> = (props) => {
  const {
    form,
    fieldList,
    itemsList,
    onFieldsChange,
    aiAuditErrorReasonForField,
    frontendHintText,
  } = props
  // eslint-disable-next-line
  const [levelState, setlevelState] = useState<string>('')
  const [codeList, setCodeList] = useState<string[]>([])
  useEffect(() => {
    const l = form.getFieldValue('level')
    setlevelState(l)
    // eslint-disable-next-line
  }, [form.getFieldValue('level')])

  useEffect(() => {
    setCodeList(itemsList?.map((item: PlatformField) => item.code) as string[])
  }, [itemsList])
  useEffect(() => {
    setCodeList(itemsList?.map((item: PlatformField) => item.code) as string[])
    // eslint-disable-next-line
  }, [])
  const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  }
  const itemLayou = {
    style: {
      width: '20%',
      marginBottom: '10px',
    },
  }

  // 字符串截取
  function changestrlength(value: any) {
    let title = null
    let styleObj = {}
    const name = value.name
    const index = 4
    if (isSameCode(codeList, value.platformCodeLabel)) {
      title = (
        <span>
          {value.name} <br />
          平台要求: {value.platformAbbreviationName}
        </span>
      )
      styleObj = { color: 'blue' }
    } else {
      title = value.name
    }
    if (name?.length > index) {
      const str = name.substring(0, index)
      return (
        <Tooltip title={title} getTooltipContainer={() => document.body}>
          <span style={styleObj}>{`${str}...`}</span>
        </Tooltip>
      )
    } else {
      return (
        <Tooltip title={title} getTooltipContainer={() => document.body}>
          <span style={styleObj}>{name}</span>
        </Tooltip>
      )
    }
  }
  // 判断两个数组中是否有相同项
  // arr1->当前选择的项目  arr2->当前属性所标记的项目属性组
  const isSameCode = (arr1: string[], arr2: string[]) => {
    let flag = false
    if (arr2 && arr1) {
      arr2.forEach((item) => {
        if (arr1.includes(item)) {
          flag = true
        }
      })
    }
    return flag
  }

  return (
    <>
      <Form
        {...formItemLayout}
        // name='expandattr'
        form={form}
        onFieldsChange={onFieldsChange}
        labelAlign="right"
        colon={false}
        style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
        size="small"
      >
        {frontendHintText ? (
          <div
            style={{
              margin: '8px 0',
              padding: '8px 12px',
              backgroundColor: '#fffbe6',
              border: '1px solid #ffe58f',
              borderRadius: '4px',
              color: '#614700',
              lineHeight: '1.6',
              whiteSpace: 'normal',
              wordBreak: 'break-all',
            }}
          >
            {frontendHintText}
          </div>
        ) : null}
        {/* 拓展属性 */}
        <Row className="expand-attr">
          {fieldList.map((item, index) => {
            const valueType = item.valueType || '2'
            const isDateType = valueType === '4'
            const placeholder =
              item.platformAbbreviationName &&
              isSameCode(codeList, item?.platformCodeLabel || [])
                ? item.platformAbbreviationName
                : '请输入'

            const dateValueProps = isDateType ? getDateValueProps() : {}

            return (
              <Form.Item
                key={index}
                label={changestrlength(item)}
                name={item.id}
                rules={getFieldRules(item as ExpandAttrFieldItem)}
                {...dateValueProps}
                {...itemLayou}
              >
                {renderFormControl({
                  item: item as ExpandAttrFieldItem,
                  placeholder,
                  form,
                })}
              </Form.Item>
            )
          })}
        </Row>
        <Tooltip
          placement="top"
          title={aiAuditErrorReasonForField?.join('\n')}
          overlayClassName={Style['custom-tooltip']}
          getPopupContainer={() => document.body}
        >
          {aiAuditErrorReasonForField?.map((i: any, index: number) => (
            <Typography.Text style={{ color: '#F57F17' }} ellipsis key={index}>
              {i}
            </Typography.Text>
          ))}
        </Tooltip>
      </Form>
    </>
  )
}

export default Expandattr
